<template>
  <ModalComponent class="comment-modal" :show="show" @close="onClose">
    <Card theme="flat">
      <template #default>
        <slot />
        <CommentInput
          :show-internal="false"
          ref="input"
          @submit="data => $emit('submit', data)"
          :promise="promise"
          @onSuccess="onClose"
        >
          <template #actions>
            <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="onClose" />
          </template>
        </CommentInput>
      </template>
    </Card>
  </ModalComponent>
</template>

<script>
import { ModalComponent } from 'vue-elder-modal'
import Card from '@/components/Card'
import CommentInput from '@/components/Comment/Input'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    promise: Promise,
  },
  methods: {
    onClose() {
      this.$emit('close')
      this.$emit('update:show', false)
    },
  },
  components: {
    ModalComponent,
    Card,
    CommentInput,
  },
}
</script>

<style lang="scss">
.comment-modal {
  .elder-input__element {
    border-radius: var(--border-radius);
    min-width: 500px;
    min-height: 150px;
  }

  .card__footer-content {
    justify-content: end;
  }
}
</style>
